module.exports = __webpack_public_path__ + "img/teacher-pic001.f5e56252.png";